import { render, staticRenderFns } from "./FolderSelector.vue?vue&type=template&id=4c86cbd6&scoped=true"
import script from "./FolderSelector.vue?vue&type=script&lang=js"
export * from "./FolderSelector.vue?vue&type=script&lang=js"
import style0 from "./FolderSelector.vue?vue&type=style&index=0&id=4c86cbd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c86cbd6",
  null
  
)

export default component.exports